export function checkPlans(file) {
  return file["extension"] == "oc5p";
}
